import {
  IDLE_DETECTION_RESUMED_EVENT,
  IDLE_DETECTION_SUSPENDED_EVENT,
  isIdleDetectionSuspended
} from "../utils/idle-detection-suspender";

/**
 * Emits an "exit" event when a user has stopped using the app for a certain period of time
 * @system exit-on-blur
 */
AFRAME.registerSystem("exit-on-blur", {
  init() {
    this.onBlur = this.onBlur.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onTimeout = this.onTimeout.bind(this);
    this.onEnterVR = this.onEnterVR.bind(this);
    this.onIdleDetectionSuspended = this.onIdleDetectionSuspended.bind(this);
    this.onIdleDetectionResumed = this.onIdleDetectionResumed.bind(this);

    this.isOculusBrowser = navigator.userAgent.match(/Oculus/);
    this.enteredVR = false;

    window.addEventListener("blur", this.onBlur);
    window.addEventListener("focus", this.onFocus);
    window.addEventListener(IDLE_DETECTION_SUSPENDED_EVENT, this.onIdleDetectionSuspended);
    window.addEventListener(IDLE_DETECTION_RESUMED_EVENT, this.onIdleDetectionResumed);
    this.el.addEventListener("enter-vr", this.onEnterVR);

    this.lastTimeoutCheck = 0;
    this.exitTimeout = null;

    this.wakeLock();
  },

  tick(t) {
    // This is a hack to detect when an Oculus Go user has taken off the headset and the headset has
    // entered standby mode. Currently Oculus Browser is not emitting a blur, vrdisplaydeactivate,
    // vrdisplayblur, visibilitychange, or vrdisplaypresentchange event, so we wait 15 seconds after
    // the last requestAnimationFrame callback to determine if the headset has gone into standby mode.
    // We also check that you have entered VR so that this timeout does not occur in the setup UI.
    if (
      this.isOculusBrowser &&
      this.enteredVR &&
      (this.lastTimeoutCheck === 0 || t - this.lastTimeoutCheck >= 1000.0) // Don't do this clear every frame, slow.
    ) {
      this.lastTimeoutCheck = t;
      clearTimeout(this.exitTimeout);
      this.exitTimeout = setTimeout(this.onTimeout, 30 * 1000);
    }
  },

  onEnterVR() {
    this.enteredVR = true;
  },

  onBlur() {
    if (this.el.isMobile && !isIdleDetectionSuspended()) {
      clearTimeout(this.exitTimeout);
      this.exitTimeout = setTimeout(this.onTimeout, 30 * 1000);
    }
  },

  onFocus() {
    if (this.el.isMobile) {
      clearTimeout(this.exitTimeout);
    }
  },

  onTimeout() {
    if (window.APP.store.state.preferences.disableIdleDetection || isIdleDetectionSuspended()) return;
    this.el.dispatchEvent(new CustomEvent("exit"));
  },

  onIdleDetectionSuspended() {
    clearTimeout(this.exitTimeout);
  },

  onIdleDetectionResumed() {},

  remove() {
    clearTimeout(this.exitTimeout);
    window.removeEventListener("blur", this.onBlur);
    window.removeEventListener("focus", this.onFocus);
    window.removeEventListener(IDLE_DETECTION_SUSPENDED_EVENT, this.onIdleDetectionSuspended);
    window.removeEventListener(IDLE_DETECTION_RESUMED_EVENT, this.onIdleDetectionResumed);
  },

  async wakeLock() {
    try {
      await navigator.wakeLock.request("screen");
    } catch (err) {
      console.error(`${err.name}, ${err.message}`);
    }
  }
});
